@use "ui/styles/fontsOld";
@use "ui/oldStyles/grid";
@use "ui/oldStyles/theme";

.wrapper {
  align-items: center;
  justify-content: space-between;

  @media only screen and (min-width: grid.$grid-desktop-breakpoint) {
    padding-top: 0;
  }

  color: theme.fetch(theme.$light, "colors", "tertiary");

  :global {
    .twitter {
      background-image: url("/static/svg/twitter-light.svg");

      &:hover,
      &:focus,
      &:active {
        background-image: url("/static/svg/twitter-light-color.svg");
      }
    }

    .facebook {
      background-image: url("/static/svg/fb-light.svg");

      &:hover,
      &:focus,
      &:active {
        background-image: url("/static/svg/fb-light-color.svg");
      }
    }

    .linkedin {
      background-image: url("/static/svg/linkedin-light.svg");

      &:hover,
      &:focus,
      &:active {
        background-image: url("/static/svg/linkedin-light-color.svg");
      }
    }

    .instagram {
      background-image: url("/static/svg/instagram-light.svg");

      &:hover,
      &:focus,
      &:active {
        background-image: url("/static/svg/instagram-light-color.svg");
      }
    }

    .top {
      min-height: 1px;
      width: 100vw;
      box-shadow: 0 -1px 0 0 theme.fetch(theme.$light, "colors", "dividers");
    }

    .left {
      text-align: center;
      display: block;
      margin: 20px auto 0;

      & .link {
        display: block;
        margin: 20px 0;
      }

      @media only screen and (min-width: grid.$grid-desktop-breakpoint) {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 250px;
        text-align: left;
        margin: 20px 0;
      }
    }

    .copyright-desktop {
      font-size: fontsOld.$small;
      display: none;

      @media only screen and (min-width: grid.$grid-desktop-breakpoint) {
        display: flex;
      }
    }

    .leftContentWrapper {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border: 1px solid red;
    }

    .dot-seperator {
      display: none;

      @media only screen and (min-width: grid.$grid-desktop-breakpoint) {
        font-size: fontsOld.$small;
        margin: 0px 4px;
        display: flex;
      }
    }

    .copyright-mobile {
      display: block;
      margin: 30px auto;

      @media only screen and (min-width: grid.$grid-desktop-breakpoint) {
        display: none;
      }
    }

    .spacer {
      display: none;

      @media only screen and (min-width: grid.$grid-desktop-breakpoint) {
        display: block;
        margin: 0 auto;
      }
    }

    .divider {
      width: 1px;
      height: 14px;
      background-color: theme.fetch(theme.$light, "colors", "dividers");
    }

    .right {
      width: 100%;
      text-align: center;
      display: block;
      margin: 20px 0;

      & .link {
        display: block;
        margin: 20px 0;
      }

      @media only screen and (min-width: grid.$grid-desktop-breakpoint) {
        display: flex;
        width: 460px;
        justify-content: space-between;
        align-items: center;
        margin: 0;

        & .link {
          display: inline-flex;
          margin: 0 auto;
        }
      }
    }

    .social {
      display: inline-flex;
      justify-content: space-between;
      width: 50%;
      max-width: 300px;
      text-align: center;

      @media only screen and (min-width: grid.$grid-desktop-breakpoint) {
        width: 112px;
        display: flex;
        align-items: center;
      }
    }

    .link {
      font-size: fontsOld.$small;
      text-decoration: none;
      transition: all 0.3s;

      color: theme.fetch(theme.$light, "colors", "links", "footer");

      &:hover {
        color: theme.fetch(theme.$light, "colors", "tertiary");
      }

      &:active {
        color: theme.fetch(theme.$light, "colors", "tertiary");
      }

      &:hover,
      &:active {
        color: theme.fetch(theme.$light, "colors", "tertiary");
      }

      &:focus {
        color: theme.fetch(theme.$light, "colors", "tertiary");
      }
    }

    .icon {
      width: 18px;
      height: 18px;
      transition: all 0.3s;
    }
  }
}
